// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// // Async thunk for fetching company locations
// export const fetchCompanyLocations = createAsyncThunk(
//   "companyLocations/fetchCompanyLocations",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await fetch(
//         "http://localhost:3000/super-admin/company-locations"
//       );
//       const result = await response.json();

//       if (result.success) {
//         return result.data.locations;
//       } else {
//         return rejectWithValue("Failed to fetch locations");
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// const companyLocationsSlice = createSlice({
//   name: "companyLocations",
//   initialState: {
//     locations: [],
//     loading: false,
//     error: null,
//     selectedMonth: "January",
//   },
//   reducers: {
//     setSelectedMonth: (state, action) => {
//       state.selectedMonth = action.payload;
//     },
//     clearError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchCompanyLocations.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchCompanyLocations.fulfilled, (state, action) => {
//         state.loading = false;
//         state.locations = action.payload;
//         state.error = null;
//       })
//       .addCase(fetchCompanyLocations.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { setSelectedMonth, clearError } = companyLocationsSlice.actions;
// export default companyLocationsSlice.reducer;
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Get API base URL from environment variables
const API_BASE_URL = process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL;

// Async thunk for fetching company locations
export const fetchCompanyLocations = createAsyncThunk(
  "companyLocations/fetchCompanyLocations",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/super-admin/company-locations`
      );
      const result = await response.json();

      if (result.success) {
        return result.data.locations;
      } else {
        return rejectWithValue("Failed to fetch locations");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const companyLocationsSlice = createSlice({
  name: "companyLocations",
  initialState: {
    locations: [],
    loading: false,
    error: null,
    selectedMonth: "January",
  },
  reducers: {
    setSelectedMonth: (state, action) => {
      state.selectedMonth = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyLocations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
        state.error = null;
      })
      .addCase(fetchCompanyLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedMonth, clearError } = companyLocationsSlice.actions;
export default companyLocationsSlice.reducer;
